export const stopScroll = () => {
    document.body.classList.add('hideScroll');
    return () => {
        document.body.classList.remove('hideScroll');
    };
};
